import IconButton from 'components/common/IconButton';
import CustomDatePicker from 'components/datepicker/CustomDatePicker';
import ItemsLoading1 from 'components/itemsLoading/ItemsLoading1';
import SelectOption from 'components/select/SelectOption';
import PopupModel from 'components/shared/PopupModel';
import { format } from 'date-fns';

import {
  getTicketAssignedUsers,
  getDrpAssetCategories,
  getDrpAssets,
  getDrpCauseOfIssues,
  getDrpCustomers,
  getDrpPriorities,
  getDrpContactTypes,
  getDrpTicketChargingTypes,
  getDrpTicketStatus,
  getDrpCompanies,
  getDrpTicketListCompanies
} from 'functions/dropdowns';
import moment from 'moment';

import React, { useEffect, useState, useContext } from 'react';
import {
  Button,
  ButtonGroup,
  Card,
  CloseButton,
  Col,
  Form,
  Modal,
  Row
} from 'react-bootstrap';
import AppContext from 'context/Context';

const TicketFilteringForm = ({
  setSelectedPriorityFunc,
  setSelectedCategoryFunc,
  setSelectedContactTypeFunc,
  setSelectedAssetFunc,
  setSelectedTicketStatusFunc,
  setSelectedTicketAssignedUserFunc,
  setSelectedCauseOfIssueFunc,
  setSelectedCustomerFunc,
  setSelectedChargingTypeFunc,
  setSelectedCompanyFunc,
  setTicketDateRangeFunc,
  clearPageIndexFunc,
  tblViewCurrentPath,
tblViewNewPath
}) => {
  const [prioritiesOps, setPrioritiesOps] = useState(null);
  const [categories, setCategories] = useState(null);
  const [contactType, setContactType] = useState(null);
  const [assets, setAssets] = useState(null);
  const [ticketStatus, setTicketStatus] = useState(null);
  const [ticketAssignedUsers, setTicketAssignedUsers] = useState(null);
  const [causeOfIssues, setCauseOfIssues] = useState(null);
  const [customers, setCustomers] = useState(null);
  const [chargingTypes, setChargingTypes] = useState(null);
  const [companies, setCommpanies] = useState(null);

  const selectedPriority_saved=localStorage.getItem('selectedPriority')? 
  JSON.parse(localStorage.getItem('selectedPriority')):null;

  const selectedCompany_saved=localStorage.getItem('selectedCompany')? JSON.parse(localStorage.getItem('selectedCompany')):null;
  const selectedCustomer_saved=localStorage.getItem('selectedCustomer')? JSON.parse(localStorage.getItem('selectedCustomer')):null;
  const selectedCategory_saved=localStorage.getItem('selectedCategory')? JSON.parse(localStorage.getItem('selectedCategory')):null;
  const selectedAsset_saved=localStorage.getItem('selectedAsset')? JSON.parse(localStorage.getItem('selectedAsset')):null;
  const selectedTicketAssignedUser_saved=localStorage.getItem('selectedTicketAssignedUser')? JSON.parse(localStorage.getItem('selectedTicketAssignedUser')):null;
  const selectedContactType_saved=localStorage.getItem('selectedContactType')? JSON.parse(localStorage.getItem('selectedContactType')):null;

 // const selectedFromDate_saved=localStorage.getItem('selectedFromDate')? JSON.parse(localStorage.getItem('selectedFromDate')):null;
  //const selectedToDate_saved=localStorage.getItem('selectedToDate')? JSON.parse(localStorage.getItem('selectedToDate')):null;


  const [selectedPriority, setSelectedPriority] = useState(selectedPriority_saved);
  const [selectedCompany, setSelectedCompany] = useState(selectedCompany_saved);
  const [selectedCustomer, setSelectedCustomer] = useState(selectedCustomer_saved);
  const [selectedCategory, setSelectedCategory] = useState(selectedCategory_saved);
  const [selectedAsset, setSelectedAsset] = useState(selectedAsset_saved);
  const [selectedTicketAssignedUser, setSelectedAgent] = useState(selectedTicketAssignedUser_saved);
  const [selectedContactType, setSelectedContactType] = useState(selectedContactType_saved);

  //const [selectedTicketStatus,setSelectedTicketStatus]=useState(5);

  //const [selectedCauseOfIssue,setSelectedCauseOfIssue]=useState(null);

  //const [selectedChargingType,setSelectedChargingType]=useState(null);

  const parseDate = dateStr => {
    const date = new Date(dateStr);
    return isNaN(date.getTime()) ? null : date;
  };
  
  // Retrieve and parse dates from localStorage
  const selectedFromDate_saved = localStorage.getItem('selectedFromDate') 
    ? parseDate(localStorage.getItem('selectedFromDate')) 
    : null;
  const selectedToDate_saved = localStorage.getItem('selectedToDate') 
    ? parseDate(localStorage.getItem('selectedToDate')) 
    : null;


    const [ticketDateRange, setTicketDateRange] = useState({
      fromDate: selectedFromDate_saved,
      toDate: selectedToDate_saved,
    });

  // const [ticketDateRange, setTicketDateRange] = useState({
  //   fromDate: selectedFromDate_saved,
  //   toDate: null,
  // });

  
useEffect(()=>{
  //dispatch(setSelectedDropdownValue({ dropdownType: 'selectedPriority', value:selectedPriority})); 
localStorage.setItem('selectedPriority',JSON.stringify(selectedPriority));
},[selectedPriority])

useEffect(()=>{
  localStorage.setItem('selectedCompany',JSON.stringify(selectedCompany));
  },[selectedCompany])

  useEffect(()=>{
    localStorage.setItem('selectedCustomer',JSON.stringify(selectedCustomer));
    },[selectedCustomer])

    useEffect(()=>{
      localStorage.setItem('selectedCategory',JSON.stringify(selectedCategory));
      },[selectedCategory])

      useEffect(()=>{
        localStorage.setItem('selectedAsset',JSON.stringify(selectedAsset));
        },[selectedAsset])
        
        useEffect(()=>{
          localStorage.setItem('selectedTicketAssignedUser',JSON.stringify(selectedTicketAssignedUser));
          },[selectedTicketAssignedUser])

          useEffect(()=>{
            localStorage.setItem('selectedContactType',JSON.stringify(selectedContactType));
            },[selectedContactType])


            useEffect(() => {
              console.log('ticketDateRange.fromDate', ticketDateRange.fromDate);
            
              // Use correct date format for Moment.js 
              const fromDate = ticketDateRange.fromDate 
                ? moment(ticketDateRange.fromDate).format('YYYY-MM-DD HH:mm:ss') 
                : null;
              const toDate = ticketDateRange.toDate 
                ? moment(ticketDateRange.toDate).format('YYYY-MM-DD HH:mm:ss') 
                : null;
            
              // Save formatted dates to localStorage
              localStorage.setItem('selectedFromDate', fromDate);
              localStorage.setItem('selectedToDate', toDate);
            }, [ticketDateRange]);
            
    
          
  const [isPriorityDrpLoading, setIsPriorityDrpLoading] = useState(false);
  const [isCategoryDrpLoading, setIsCategoryDrpLoading] = useState(false);
  const [isContactTypeDrpLoading, setIsContactTypeDrpLoading] = useState(false);
  const [isAssetDrpLoading, setIsAssetDrpLoading] = useState(false);
  const [isTicketStatusDrpLoading, setIsTicketStatusDrpLoading] =useState(false);

  const [isTicketAssignedUsersLoading, setTicketAssignedUsersLoading] =useState(false);
  const [isCauseOfIssueDrpLoading, setIsCauseOfIssueDrpLoading] = useState(false);
  const [isCustomerDrpLoading, setIsCustomerDrpLoading] = useState(false);
  const [isChargingTypeDrpLoading, setIsChargingTypeDrpLoading] =useState(false);


  const [isCompanyDrpLoading, setIsCompanyDrpLoading] = useState(false);

  const [isDateRangeModelShow, setIsDateRangeModelShow] = useState(false);

  const _userData = JSON.parse(localStorage.getItem('userData'));

  const { config } = useContext(AppContext);
  const { isDark } = config;
  const textColor = isDark ? '#fff' : '#212529';

  useEffect(() => {
    console.log('selectedPriority',selectedPriority)
    setSelectedPriorityFunc(selectedPriority);
  }, [selectedPriority]);

  useEffect(() => {
    setSelectedCategoryFunc(selectedCategory);
  }, [selectedCategory]);

  useEffect(() => {
    setSelectedContactTypeFunc(selectedContactType);
  }, [selectedContactType]);

  useEffect(() => {
    setSelectedAssetFunc(selectedAsset);
  }, [selectedAsset]);

  useEffect(() => {
    if (
      (ticketDateRange.fromDate && ticketDateRange.toDate) ||
      (!ticketDateRange.fromDate && !ticketDateRange.toDate)
    ) {
      setTicketDateRangeFunc(ticketDateRange);
      setIsDateRangeModelShow(false);
    }
  }, [ticketDateRange]);

  // useEffect(() => {
  //   setSelectedTicketStatusFunc(selectedTicketStatus);
  // }, [selectedTicketStatus]);

  useEffect(() => {
    setSelectedTicketAssignedUserFunc(selectedTicketAssignedUser);
  }, [selectedTicketAssignedUser]);

  // useEffect(() => {
  //   setSelectedCauseOfIssueFunc(selectedCauseOfIssue);
  // }, [selectedCauseOfIssue]);

  useEffect(() => {
    setSelectedCustomerFunc(selectedCustomer);
  }, [selectedCustomer]);

  // useEffect(() => {
  //   setSelectedChargingTypeFunc(selectedChargingType);
  // }, [selectedChargingType]);

  useEffect(() => {
    setSelectedCompanyFunc(selectedCompany);
  }, [selectedCompany]);

  const formattedFromDate = ticketDateRange.fromDate
    ? format(ticketDateRange.fromDate, 'yyyy-MMM-dd') // Adjust the format as needed
    : '';
  const formattedToDate = ticketDateRange.toDate
    ? format(ticketDateRange.toDate, 'yyyy-MMM-dd') // Adjust the format as needed
    : '';

  useEffect(() => {
    console.log('useEffect');
    loadDrpPriorities();
    loadDrpAssetCategories();
    loadDrpAssets();
    loadDrpContactType();
    // loadDrpTicketStatus();
    loadDrpTicketAssignedUsers();
    loadDrpCauseOfIssues();
    loadDrpCustomers();
    loadDrpChargingTypes();
    loadDrpCompanies();
  }, []);

  const clearFilter = () => {
    setSelectedPriority(null);
    setSelectedCategory(null);
    setSelectedAsset(null);
    setSelectedAgent(null);
    setSelectedCustomer(null);
    setSelectedCompany(null);
    setTicketDateRange({ fromDate: null, toDate: null });
    clearPageIndexFunc();
  };


useEffect(()=>{
  console.log('tblViewCurrentPath',tblViewCurrentPath,tblViewNewPath);
  if(tblViewCurrentPath!=tblViewNewPath){
    clearFilter();
  
    //window.scrollTo(0, 0); // Default to top if no saved position
   // console.log('location different pathname detected',location.pathname,localStorage.getItem('currentPathName'));
  }
},[tblViewCurrentPath,tblViewNewPath])



  const loadDrpPriorities = async () => {
    try {
      setIsPriorityDrpLoading(true);
      const res = await getDrpPriorities();
      const data = res.data;
      const options = [{ value: '-1', text: 'All' }];
      data &&
        data.map(d => {
          options.push({ value: d.value, text: d.text });
        });
      setPrioritiesOps(options);
      setIsPriorityDrpLoading(false);
    } catch (err) {
      console.log('Error', err);
    }
  };

  const loadDrpAssetCategories = async () => {
    try {
      setIsCategoryDrpLoading(true);
      const res = await getDrpAssetCategories();
      const data = res.data;
      const options = [{ value: '-1', text: 'All' }];
      data &&
        data.map(d => {
          options.push({ value: d.value, text: d.text });
        });
      setCategories(options);
      setIsCategoryDrpLoading(false);
    } catch (err) {
      console.log('Error', err);
    }
  };

  const loadDrpCompanies = async () => {
    try {
      const token = localStorage.getItem('token');
      setIsCompanyDrpLoading(true);
      const res = await getDrpTicketListCompanies(token);
      const data = res.data;
      const options = [{ value: '-1', text: 'All' }];
      data &&
        data.map(d => {
          options.push({ value: d.value, text: d.text });
        });
      setCommpanies(options);
      setIsCompanyDrpLoading(false);
    } catch (err) {
      console.log('Error', err);
    }
  };

  // Repeat the same pattern for the remaining functions...

  const loadDrpAssets = async () => {
    try {
      setIsAssetDrpLoading(true);
      const res = await getDrpAssets();
      const data = res.data;
      const options = [{ value: '-1', text: 'All' }];
      data &&
        data.map(d => {
          options.push({ value: d.value, text: d.text });
        });
      setAssets(options);
      setIsAssetDrpLoading(false);
    } catch (err) {
      console.log('Error', err);
    }
  };

  const loadDrpContactType = async () => {
    try {
      const token = localStorage.getItem('token');
      setIsContactTypeDrpLoading(true);
      const res = await getDrpContactTypes(token);
      const data = res.data;
      const options = [{ value: '-1', text: 'All' }];
      data &&
        data.map(d => {
          options.push({ value: d.value, text: d.text });
        });
      setContactType(options);
      setIsContactTypeDrpLoading(false);
    } catch (err) {
      console.log('Error', err);
    }
  };

  const loadDrpTicketStatus = async () => {
    try {
      setIsTicketStatusDrpLoading(true);
      const res = await getDrpTicketStatus();
      const data = res.data;
      const options = [{ value: '', text: 'All' }];
      data &&
        data.map(d => {
          options.push({ value: d.value, text: d.text });
        });
      setTicketStatus(options);
      setIsTicketStatusDrpLoading(false);
    } catch (err) {
      console.log('Error', err);
    }
  };

  const loadDrpTicketAssignedUsers = async () => {
    try {
      setTicketAssignedUsersLoading(true);
      const token = localStorage.getItem('token');
      const res = await getTicketAssignedUsers(token);
      const data = res.data;
      const options = [{ value: '-1', text: 'All' }];
      data &&
        data.map(d => {
          options.push({ value: d.value, text: d.text });
        });
      setTicketAssignedUsers(options);
      setTicketAssignedUsersLoading(false);
    } catch (err) {
      console.log('Error', err);
    }
  };

  const loadDrpCauseOfIssues = async () => {
    try {
      setIsCauseOfIssueDrpLoading(true);
      const res = await getDrpCauseOfIssues();
      const data = res.data;
      const options = [{ value: '-1', text: 'All' }];
      data &&
        data.map(d => {
          options.push({ value: d.value, text: d.text });
        });
      setCauseOfIssues(options);
      setIsCauseOfIssueDrpLoading(false);
    } catch (err) {
      console.log('Error', err);
    }
  };

  const loadDrpCustomers = async () => {
    try {
      setIsCustomerDrpLoading(true);
      const res = await getDrpCustomers();
      const data = res.data;
      const options = [{ value: '-1', text: 'All' }];
      data &&
        data.map(d => {
          options.push({ value: d.value, text: d.text });
        });
      setCustomers(options);
      setIsCustomerDrpLoading(false);
    } catch (err) {
      console.log('Error', err);
    }
  };

  const loadDrpChargingTypes = async () => {
    try {
      setIsChargingTypeDrpLoading(true);
      const res = await getDrpTicketChargingTypes();
      const data = res.data;
      const options = [{ value: '-1', text: 'All' }];
      data &&
        data.map(d => {
          options.push({ value: d.value, text: d.text });
        });
      setChargingTypes(options);
      setIsChargingTypeDrpLoading(false);
    } catch (err) {
      console.log('Error', err);
    }
  };

  return (
    <Card className="shadow-none shadow-show-xl scrollbar">
      <Card.Header className="bg-light d-none d-xl-block" style={{ color: textColor, background: isDark ? undefined : undefined }}>
        <div className="row align-items-center">
          <div className="col-4">
            <h6 className="mb-0" style={{ color: textColor, whiteSpace: 'nowrap', fontSize: '1rem', minWidth: '60px' }}>Filter</h6>
          </div>
          <div className="col-8 text-end">
            <IconButton
              className="rounded-pill me-1 mb-1"
              onClick={clearFilter}
              variant="falcon-default"
              icon="redo-alt"
              transform="shrink-3"
              size="sm"
              style={{ color: textColor }}
            >
              
            </IconButton>
          </div>
        </div>
      </Card.Header>

      <Card.Body style={{ color: textColor, background: isDark ? '#23272b' : undefined }}>
        <Form>
          {/* Add a style tag to enforce label color */}
          <style>{`
            .ticket-filter-form-label { color: ${textColor} !important; }
          `}</style>
          {/* <div className="mb-2">
            <Form.Label className="mb-1 mt-2 fs--1">Status</Form.Label>
            {isTicketStatusDrpLoading ? (
              <ItemsLoading1
                animation="border"
                size="sm"
                message="Loading..."
              />
            ) : (
              <SelectOption
                size="sm"
                options={ticketStatus}
                handleChange={e => {
                  setSelectedTicketStatus(
                    e.target.value === '' ? null : e.target.value
                  );
                }}
                selectedValue={selectedTicketStatus}
              />
            )}
          </div> */}
          <div className="mb-2 mt-2">
            <Form.Label className="mb-1 fs--1 ticket-filter-form-label">Priority</Form.Label>
            {isPriorityDrpLoading ? (
              <ItemsLoading1
                animation="border"
                size="sm"
                message="Loading..."
              />
            ) : (
              <SelectOption
                size="sm"
                options={prioritiesOps}
                handleChange={e => {

                  console.log('drodown priority selected');
                  clearPageIndexFunc();
                  setSelectedPriority(
                    e.target.value
                  );
                }}
                selectedValue={selectedPriority}
              />
            )}
          </div>
          <div className="mb-2">
            <Form.Label className="mb-1 mt-2 fs--1 ticket-filter-form-label">Company</Form.Label>
            {isCompanyDrpLoading ? (
              <ItemsLoading1
                animation="border"
                size="sm"
                message="Loading..."
              />
            ) : (
              <SelectOption
                size="sm"
                options={companies}
                handleChange={e => {
                  clearPageIndexFunc();
                  setSelectedCompany(
                    e.target.value === '' ? null : e.target.value
                  );
                }}
                selectedValue={selectedCompany}
              />
            )}
          </div>

          {_userData.roleId === 3 && (
            <div className="mb-2">
              <Form.Label className="mb-1 mt-2 fs--1 ticket-filter-form-label">
                Ticket Initiator
              </Form.Label>
              {isCustomerDrpLoading ? (
                <ItemsLoading1
                  animation="border"
                  size="sm"
                  message="Loading..."
                />
              ) : (
                <SelectOption
                  size="sm"
                  options={customers}
                  handleChange={e => {
                    clearPageIndexFunc();
                    setSelectedCustomer(
                      e.target.value === '' ? null : e.target.value
                    );
                  }}
                  selectedValue={selectedCustomer}
                />
              )}
            </div>
          )}
          <div className="mb-2">
            <Form.Label className="mb-1 mt-2 fs--1 ticket-filter-form-label">Category</Form.Label>
            {isCategoryDrpLoading ? (
              <ItemsLoading1
                animation="border"
                size="sm"
                message="Loading..."
              />
            ) : (
              <SelectOption
                size="sm"
                options={categories}
                handleChange={e => {
                  clearPageIndexFunc();
                  setSelectedCategory(
                    e.target.value === '' ? null : e.target.value
                  );
                }}
                selectedValue={selectedCategory}
              />
            )}
          </div>

          <div className="mb-2">
            <Form.Label className="mb-1 mt-2 fs--1 ticket-filter-form-label">Asset</Form.Label>
            {isAssetDrpLoading ? (
              <ItemsLoading1
                animation="border"
                size="sm"
                message="Loading..."
              />
            ) : (
              <SelectOption
                size="sm"
                options={assets}
                handleChange={e => {
                  clearPageIndexFunc();
                  setSelectedAsset(
                    e.target.value === '' ? null : e.target.value
                  );
                }}
                selectedValue={selectedAsset}
              />
            )}
          </div>
          <div className="mb-2">
            <Form.Label className="mb-1 mt-2 fs--1 ticket-filter-form-label">Assignee</Form.Label>
            {isTicketAssignedUsersLoading ? (
              <ItemsLoading1
                animation="border"
                size="sm"
                message="Loading..."
              />
            ) : (
              <SelectOption
                size="sm"
                options={ticketAssignedUsers}
                handleChange={e => {
                  clearPageIndexFunc();
                  setSelectedAgent(
                    e.target.value === '' ? null : e.target.value
                  );
                }}
                selectedValue={selectedTicketAssignedUser}
              />
            )}
          </div>

          {/* <div className="mb-2">
            <Form.Label className="mb-1 mt-2 fs--1">Cause of Issue</Form.Label>
            {isCauseOfIssueDrpLoading ? (
              <ItemsLoading1
                animation="border"
                size="sm"
                message="Loading..."
              />
            ) : (
              <SelectOption
                size="sm"
                options={causeOfIssues}
                handleChange={e => {
                  setSelectedCauseOfIssue(
                    e.target.value === '' ? null : e.target.value
                  );
                }}
                selectedValue={selectedCauseOfIssue}
              />
            )}
          </div> */}

          <div className="mb-2">
            <Form.Label className="mb-1 mt-2 fs--1 ticket-filter-form-label">Contact Type</Form.Label>
            {isContactTypeDrpLoading ? (
              <ItemsLoading1
                animation="border"
                size="sm"
                message="Loading..."
              />
            ) : (
              <SelectOption
                size="sm"
                options={contactType}
                handleChange={e => {
                  clearPageIndexFunc();
                  setSelectedContactType(
                    e.target.value === '' ? null : e.target.value
                  );
                }}
                selectedValue={selectedContactType}
              />
            )}
          </div>

          <div className="mb-4 mt-4">
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <IconButton
                className="rounded-pill me-1 mb-1"
                onClick={() => {

                  setIsDateRangeModelShow(true);
                }}
                variant="primary"
              //  icon="fa-calendar-days"
                transform="shrink-3"
                size="sm"
              >
                Select Date
              </IconButton>
            </div>

            {ticketDateRange.fromDate && ticketDateRange.toDate && (
              <div style={{ marginTop: '10px' }}>
                <Row>
                  <Col md={8}>
                    <Row>
                      <Col md={3}>
                        <Form.Label className="mb-1 mt-1 fs--1 ticket-filter-form-label">
                          From:{' '}
                        </Form.Label>
                      </Col>
                      <Col md={9}>
                        <Form.Label className="mb-1 mt-1 fs--1 ticket-filter-form-label">
                          {formattedFromDate}
                        </Form.Label>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={3}>
                        <Form.Label className="mb-1 mt-1 fs--1 ticket-filter-form-label">
                          To:{' '}
                        </Form.Label>
                      </Col>
                      <Col md={9}>
                        <Form.Label className="mb-1 mt-1 fs--1 ticket-filter-form-label">
                          {formattedToDate}
                        </Form.Label>
                      </Col>
                    </Row>
                  </Col>

                  <Col md={4}>
                    {' '}
                    <IconButton
                      className="rounded-pill me-1 mb-1"
                      onClick={() => {  
                        clearPageIndexFunc();
                        setTicketDateRange({ fromDate: null, toDate: null });
                      }}
                      variant="falcon-default"
                      icon=" fa-calendar-days"
                      transform="shrink-3"
                      size="sm"
                    >
                      Clear
                    </IconButton>
                  </Col>
                </Row>
              </div>
            )}
          </div>

          <PopupModel
            isShow={isDateRangeModelShow}
            header="Select Date Range"
            size="sm"
            onHide={() => {
              setIsDateRangeModelShow(false);
            }}
          >
            <div className="mb-2 p-3 pt-2">
              <div
                className="mb-2"
                style={{ display: 'flex', flexDirection: 'column' }}
              >
                <Form.Label
                  className="mb-0 mt-1"
                  style={{ fontWeight: 'normal' }}
                >
                  From
                </Form.Label>
                <CustomDatePicker
                  style={{ width: '100%' }} // Set a specific width here
                  selected={ticketDateRange.fromDate}
                  onChange={value => {
                    //console.log('Selected From Date:', value);
                    clearPageIndexFunc();
                    setTicketDateRange({ ...ticketDateRange, fromDate: value });
                  }}
                />
              </div>

              <div
                className="mb-2"
                style={{ display: 'flex', flexDirection: 'column' }}
              >
                <Form.Label
                  className="mb-0 mt-1"
                  style={{ fontWeight: 'normal' }}
                >
                  To
                </Form.Label>
                <CustomDatePicker
                  style={{ width: '100%' }} // Set the same specific width here
                  selected={ticketDateRange.toDate}
                  onChange={value => {
                    // console.log('Selected To Date:', value);
                    clearPageIndexFunc();
                    setTicketDateRange({ ...ticketDateRange, toDate: value });
                  }}
                />
              </div>

              {/* <div
                className=""
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center'
                }}
              >
                <IconButton
                  variant="primary"
                  onChange={() => {
                    setIsDateRangeModelShow(false);
                  }}
                >
                  OK
                </IconButton>
              </div> */}
            </div>
          </PopupModel>

          {/* <div className="mb-2">
            <Form.Label className="mb-1 mt-2 fs--1">Charging Type</Form.Label>
            {isChargingTypeDrpLoading ? (
              <ItemsLoading1
                animation="border"
                size="sm"
                message="Loading..."
              />
            ) : (
              <SelectOption
                size="sm"
                options={chargingTypes}
                handleChange={e => {
                  setSelectedChargingType(
                    e.target.value === '' ? null : e.target.value
                  );
                }}
                selectedValue={selectedChargingType}
              />
            )}
          </div> */}

          {/*   <div>
            <Form.Label className="mb-1 mt-2 fs--1">Subscription</Form.Label>
            <Form.Select size="sm">
              <option>None</option>
              <option>Active</option>
              <option>Inactive</option>
              <option>Expired</option>
              <option>Pending</option>
            </Form.Select>
          </div> */}
        </Form>
      </Card.Body>
      {/* <Card.Footer className="border-top border-200 py-x1">
        <Button varient="primary" className="w-100">
          Search
        </Button>
      </Card.Footer> */}
    </Card>
  );
};

export default TicketFilteringForm;
